module.exports = __webpack_public_path__ + "assets/addtoany-share-buttons.4f92b8b6.svg";